/* eslint-disable react-hooks/exhaustive-deps */

import React, { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
// Formik
import { Formik } from 'formik';
import * as Yup from 'yup';
// CSS
import '../SignUp/SignUp.css';
import './SignIn.css';
//
import Button from '../../components/Button';
import Input from '../../components/Input';
import InputPassword from 'container/components/InputPassword';
import ErrorMessage from 'container/components/ErrorMessage';
import Spinner from 'container/components/Spinner';
import GoogleLogin from 'container/components/GoogleLogin/GoogleLogin';
import styled from 'styled-components';
import assets from 'assets';
import TopBanner from '../TopBanner/TopBanner';
import { useAssets } from 'assets/useIcons';
// import SalesBanner from 'container/components/SalesBanner/SalesBanner';
// import { bannerText } from 'app.config';

const SignInSchema = Yup.object().shape({
  email: Yup.string()
    .email('Must be a valid email')
    .min(6)
    .required('Email is required'),
  password: Yup.string()
    .min(5, 'Too Short!')
    .max(50, 'Too Long!')
    .required('Password Required'),
});

function SignIn({ bittensor }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loading = useSelector(state => state.auth.loading);
  const dLoading = useSelector(state => state.auth.loading);
  const { topBanner } = useSelector(state => state.utils);

  const newAssets = useAssets();

  const params = new URLSearchParams(window.location.search);
  const playground_user = params.get('playground_user');
  // const discountCode = params.get('discount_code');
  // const imageGeneration = params.get('image-generation');
  // const buyPlan = params.get('buy_plan');

  // useEffect(() => {
  //   dispatch.utils.setTopBanner(true)
  //   dispatch.utils.setGiftCard(true)
  // }, [])

  return (
    <>
      {topBanner && <TopBanner isBtn={false} />}
      <Container style={{ height: topBanner ? '90vh' : '100vh' }}>
        <Fragment>
          <div className='container'>
            {/* Logo */}
            {playground_user ? (
              <div className='row sign__in-logo'>
                <div className='col-md-12'>
                  <Link to='/'>
                    <img src={assets.pgchataiFullLogo} alt='' />
                  </Link>
                </div>
              </div>
            ) : (
              <div className='row sign__in-logo'>
                <div className='col-md-12'>
                  <img src={newAssets.logo} style={{ width: '180px' }} alt='' />
                </div>
              </div>
            )}

            {/* BOX Container */}
            <div className='sign__in-box sign__up-box pt-4 mb-4'>
              <h1 className='account-heading'>Welcome Back</h1>
              {playground_user && (
                <>
                  <div className='sign-in-new-text'>
                    <span className='pg-users'>Playground AI users.</span>
                    <span className='detail'>
                      Please login to ChatAI using your existing Playground AI
                      email and password. Your chat history, images, and account
                      settings are all available in ChatAI. Please contact us at
                      help@chatai.com with any questions about your account
                      migration. Thank you
                    </span>
                  </div>
                </>
              )}
              <Formik
                initialValues={{ email: '', password: '' }}
                validationSchema={SignInSchema}
                onSubmit={(values, { setSubmitting }, errors) => {
                  if (bittensor) {
                    if (
                      (values.email === 'bittensor_test@gmail.com' &&
                        values.password === 'Bittensor123@') ||
                      (values.email === 'rick@chatai.com' &&
                        values.password === 'Rick@123')
                    ) {
                      dispatch.utils.setIsBittensorLogin(false);
                    }
                  } else {
                    dispatch.auth.handleLogin({
                      data: values,
                      navigate,
                      errors,
                    });
                  }

                  setTimeout(() => {
                    setSubmitting(false);
                  }, 400);
                }}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting,
                }) => (
                  <form onSubmit={handleSubmit}>
                    <Input
                      type='email'
                      name='email'
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.email}
                      className='input-email mt-4'
                      placeholder='Email Address'
                      id='sign-in-email'
                    />
                    <ErrorMessage
                      error={errors.email && touched.email && errors.email}
                      left={true}
                    />
                    <InputPassword
                      type='password'
                      name='password'
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.password}
                      className='input-email mt-4'
                      placeholder='Password'
                      eye='true'
                      id='sign-in-password'
                    />
                    <ErrorMessage
                      error={
                        errors.password && touched.password && errors.password
                      }
                      left={true}
                    />
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        width: '100%',
                      }}
                    >
                      {!bittensor && (
                        <Link
                          onClick={() => {
                            dispatch.utils.setForgetPassword('send-email');
                          }}
                          to='/forget-password'
                          style={{ width: 'unset' }}
                        >
                          <p className='forgot-password'>Forgot Password?</p>
                        </Link>
                      )}
                    </div>
                    <Button
                      text={loading || dLoading ? <Spinner /> : 'Continue'}
                      className='account-button'
                      type='submit'
                      disabled={isSubmitting || loading}
                      id='sign-in-btn'
                    />
                    <span
                      className='credit-heading'
                      style={{
                        textAlign: 'left',
                        display: 'block',
                        marginTop: '10px',
                      }}
                    >
                      By using ChatAI you agree to our{' '}
                      <a
                        href='https://chatai.com/terms-of-service/'
                        rel='noopener noreferrer'
                        style={{ color: 'white' }}
                        target='_blank'
                      >
                        terms and conditions
                      </a>
                      . We respect your{' '}
                      <a
                        href='https://chatai.com/privacy-policy/'
                        rel='noopener noreferrer'
                        style={{ color: 'white', textDecoration: 'underline' }}
                        target='_blank'
                      >
                        privacy
                      </a>
                      .
                    </span>
                  </form>
                )}
              </Formik>
              {!bittensor && (
                <>
                  <Divider>
                    <span>or</span>
                  </Divider>
                  <GoogleLogin id='signin-with-google' isSignIn={true} />
                  <p className='have-account mb-0'>
                    Don't have an account?{' '}
                    <Link to={`/sign-up?${params.toString()}`}>
                      <span>signup</span>
                    </Link>
                  </p>
                </>
              )}

              <div className='account-bottom'>
                <p>{/* Terms of use <span>|</span> Privacy Policy */}</p>
              </div>
            </div>
          </div>
        </Fragment>
      </Container>
    </>
  );
}

export default SignIn;

const Divider = styled.div`
  width: 100%;
  margin-block: 30px;
  height: 1px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 1px solid #ffffff1a;

  & span {
    color: ${({ theme }) => theme.colors.primary};
    line-height: 1;
    background-color: ${({ theme }) => theme.colors.darkbg};
    padding-inline: 10px;
    margin-top: -4px;
  }
`;

const Container = styled.div`
  display: flex;

  flex-direction: column;

  @media only screen and (max-width: 1000px) {
    .sign__up-box {
      min-width: 100% !important;
      max-width: 100% !important;
      margin-top: 18px;
    }
  }
`;
